<template>
	<div class="page">
		<van-nav-bar :title="name" class="nav-bar">
			<template #left>
				<van-icon name="arrow-left" color="#fff" @click="back()" />
			</template>
		</van-nav-bar>
		<div class="box">
<!--			<p class="name">{{ this.xuanfeidata.xuanfei_name }}</p>
			<p class="title">{{ this.xuanfeidata.vo_title }}</p>-->
			<van-image width="98%" fit="contain" height="100%" v-for="(v, k) in xuanfeidata" :key="k" :src="v" />
<!--			<van-button round="true" @click="yuyue" class="button" color="linear-gradient(to right, #7f5778 , #e5c2a0)">{{$t("foorter.subscribe")}}</van-button>-->
		</div>
	</div>
</template>

<script>
export default {
	data() {
		return {
      name : '' ,
			xuanfeidata: []
		};
	},
	methods: {
		back() {
      this.$router.push({ path: 'Choose' });
		},
		getxuanfeidata() {
			this.$http({
				method: 'get',
				url: 'chooseDetail',
				data: { id: this.$route.query.id }
			}).then(res => {
        console.log(res.data) ;
				this.xuanfeidata = res.data;
			});
		},
		yuyue() {
			this.$toast(this.$t("reservation.counselor"));
		}
	},
	created() {
    this.name = this.$route.query.name ;
    this.getxuanfeidata();
	}
};
</script>

<style>
.container {
	display: inline-block;
}
.box {
	width: 95%;
	margin: 0 auto;
	text-align: center;
	padding-bottom: 6.25rem;
}
.name {
	font-size: 1.125rem;
}
.title {
	font-size: 0.625rem;
}
.button {
	width: 10rem;
	height: 2.5rem;
	font-size: 0.9375rem;
	margin-top: 0.625rem;
}
</style>
